import { FormikProps } from "formik";
import { ResCallback } from "../../../../../models";
import { AvisConfirmButton } from "../../buttons";

interface IFilterActionsProps<T> {
  bag: FormikProps<T>;
  loading: boolean;
  res: ResCallback;
  filtered?: boolean;
}
export function FilterActions<T>(props: Readonly<IFilterActionsProps<T>>) {
  const { bag, loading, res } = props;

  return (
    <div className="filter-actions row">
      <AvisConfirmButton
        className="col-4"
        label={res("button_Filter")}
        onClick={bag.submitForm}
        disabled={loading}
      />
    </div>
  );
}
